import type { QuickStartSectionRef } from '../../github.interface'

export function resolveLanguageList(section: QuickStartSectionRef): string[] {
  if (section.languages && section.languages.length > 0) return section.languages
  return [section.defaultLanguage ?? 'default']
}
